import {Controller} from "stimulus"

export default class extends Controller {
  connect() {
    // Lock body scroll when modal opens
    this.originalOverflow = document.body.style.overflow
    document.body.style.overflow = "hidden"

    // Listen for Escape key
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundHandleKeydown)
  }

  disconnect() {
    // Restore body scroll when modal closes
    document.body.style.overflow = this.originalOverflow || ""

    // Clean up event listener
    if (this.boundHandleKeydown) {
      document.removeEventListener("keydown", this.boundHandleKeydown)
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  close() {
    // Find the parent turbo-frame and clear its content
    const turboFrame = this.element.closest("turbo-frame")
    if (turboFrame) {
      turboFrame.innerHTML = ""
    }
  }
}
